import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import {
  genericRequiredFieldError,
  SYSTEM_POWER_USAGE_TYPE,
  SYSTEM_POWER_USAGE_VALUES,
} from '../../constants';
import { LoanApplication, type PROJECT_TYPE } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    projectType,
    systemPowerUsage,
    systemPowerSingleOrMultipleUsers,
    systemPowerCommunityOrPPALease,
    systemPowerNumberOfOfftakers,
  },
} = loanFormModel;

export class NumberOfOfftakersValidation implements ValidationSchema {
  public name: string = systemPowerNumberOfOfftakers.name;
  public label: string = systemPowerNumberOfOfftakers.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [
    projectType.name,
    systemPowerUsage.name,
    systemPowerSingleOrMultipleUsers.name,
    systemPowerCommunityOrPPALease.name,
  ];
  public type = 'number';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(
    projectType: string,
    usage: SYSTEM_POWER_USAGE_TYPE,
    singleOrMultipleUsers: string,
    communityOrPPALease: string,
    schema
  ) {
    if (!projectType || !LoanApplication.isSolar(projectType as PROJECT_TYPE))
      return schema;
    if (
      usage === SYSTEM_POWER_USAGE_VALUES.SOLD_TO_ANOTHER_ENTITY &&
      singleOrMultipleUsers === 'Multiple Users' &&
      communityOrPPALease === 'PPA/Lease Agreement'
    ) {
      return schema.required(genericRequiredFieldError).min(1).max(9);
    }
    return schema;
  }
}
export default new Validation(new NumberOfOfftakersValidation());
